import { cn } from '@/lib/utils'
import { getAudienceKindLabel } from '@/utils/audience-builder'

/** Small label showing what kind of AI audience an ad set targets. */
const AudienceTypeChip = ({ kind, className = '' }) => {
    if (!kind) return null

    return (
        <span
            data-testid="audience-type-chip"
            className={cn(
                'tw:inline-flex tw:items-center tw:rounded-full tw:border tw:border-blue-300/60 tw:bg-blue-300/10 tw:px-2 tw:py-0.5 tw:text-xs tw:font-medium tw:text-blue-300',
                className,
            )}
        >
            {getAudienceKindLabel(kind)}
        </span>
    )
}

export default AudienceTypeChip
